<style type="text/css"></style>
<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          ALS 레벨테스트 응시
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            ALS 레벨테스트 → ALS 레벨테스트 응시
          </div>
        </h5>

        <div
          style="
            width: 100%;
            height: 900px;
            background: #2b2c68;
            text-align: center;
            border: 2px solid #eee;
            box-shadow: 0 0 10px #ccc;
            padding: 40px;
          "
        >
          <div
            style="
              text-align: left;
              width: 1100px;
              margin: 10px auto;
              font-size: 15px;
              margin-bottom: 0px;
              color: #fff;
              font-size: 16px;
              line-height: 20px;
            "
          >
            <p style="color: #fff">
              <span style="font-size: 28px; color: #fff; line-height: 50px"
                >본 테스트에서는
                <span style="font-weight: bold; color: #ffb600"
                  >LanguageArts 영역</span
                >
                을 평가하여</span
              ><br />
              학습자에게 적정한 학년(교재)를 안내하고 있습니다.<br />
              학습하고자 하는 레벨을 선택한 후 시험을 보고나면, 각 문항의
              평가영역과 함께 시험결과를 바로 확인할 수 있습니다.<br />
            </p>
          </div>

          <div>
            <table
              style="
                border-bottom: 0;
                background: #f0f0f0;
                width: 1100px;
                margin: 0 auto;
                padding: 20px;
                height: 60px;
              "
            >
              <colgroup>
                <col width="40px" />
                <col width="130px" />
                <col width="40px" />
                <col width="300px" />
                <col width="100px" />
                <col width="300px" />
                <col width="40px" />
                <col width="200px" />
              </colgroup>
              <tbody>
                <tr>
                  <td width="80">
                    <div>이름</div>
                  </td>
                  <td>
                    <input
                      type="text"
                      v-model="name"
                      class="test_form"
                      style="width: 130px"
                    />
                  </td>
                  <td width="80" style="padding: 10px">
                    <div>학교</div>
                  </td>
                  <td>
                    <input
                      type="text"
                      v-model="school_1"
                      class="test_form"
                      style="width: 130px; float: left"
                    />
                    <select
                      class="input_text"
                      style="width: 80px; margin-left: -30px; height: 36px"
                      v-model="school_2"
                    >
                      <option value="">선택</option>
                      <option value="초등학교">초등학교</option>
                      <option value="중학교">중학교</option>
                      <option value="고등학교">고등학교</option>
                      <option value="소속없음">소속없음</option>
                    </select>
                  </td>

                  <td width="80" style="padding: 10px">
                    <div>학년</div>
                  </td>
                  <td style="display: inline-block">
                    <select
                      class="input_text"
                      v-model="grade"
                      style="
                        width: 80px;
                        text-align: center;
                        margin-left: -150px;
                        margin-top: 11px;
                        height: 36px;
                      "
                    >
                      <option value="">선택</option>
                      <option value="1">1학년</option>
                      <option value="2">2학년</option>
                      <option value="3">3학년</option>
                      <option value="4">4학년</option>
                      <option value="5">5학년</option>
                      <option value="6">6학년</option>
                    </select>
                  </td>
                  <td width="80">
                    <div>연락처</div>
                  </td>
                  <td>
                    <input
                      name="t_phone"
                      type="text"
                      class="input_text"
                      style="width: 160px"
                      v-model="phone"
                    />
                  </td>
                  <!--th width="80"><div class="blue_th">날짜</div></th>
              <td><input type="date
                "></td>
        		  <input type="hidden" name="strGrade" -->
                </tr>
              </tbody>
            </table>
          </div>

          <div style="width: 1100px; margin: 40px auto">
            <table width="1100px" border="0" style="text-align: center">
              <tbody>
                <tr>
                  <td>
                    <img src="http://childu.co.kr/img/cpt/img_cpt1.png" />
                  </td>
                  <td>
                    <img src="http://childu.co.kr/img/cpt/img_cpt2.png" />
                  </td>
                  <td>
                    <img src="http://childu.co.kr/img/cpt/img_cpt3.png" />
                  </td>
                </tr>
                <tr>
                  <td>
                    <table
                      class="test_table"
                      style="
                        background-color: #fff;
                        font-size: 14px;
                        margin-top: 20px;
                      "
                    >
                      <tr>
                        <td
                          width="135"
                          height="30"
                          rowspan="2"
                          align="center"
                          bgcolor="#3983d1"
                          class="style39"
                          style="line-height: 20px; color: #fff"
                        >
                          Score Range
                        </td>
                        <td height="31" align="center" bgcolor="#e5f6ff">
                          <span
                            class="style63"
                            style="color: #333; font-size: 15px"
                            >추천 교재
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="192"
                          height="30"
                          align="center"
                          bgcolor="#e5f6ff"
                          class="style39"
                        >
                          <span
                            class="style63"
                            style="color: #333; font-size: 13px"
                            >Main Line</span
                          >
                        </td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="40"
                          align="center"
                          bgcolor="#f5f5f5"
                          class="style63"
                        >
                          0 ~ 60점
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA Phonics B1
                        </td>
                      </tr>
                      <tr>
                        <td height="40" align="center" class="style63">
                          60 ~ 70점
                        </td>
                        <td align="center" class="style63">LA K1</td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="40"
                          align="center"
                          bgcolor="#f5f5f5"
                          class="style63"
                        >
                          70 ~ 80점
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA Phonetic Story 1
                        </td>
                      </tr>

                      <tr>
                        <td height="40" align="center" class="style63">
                          80 ~ 90점
                        </td>
                        <td align="center" class="style63">
                          LA Phonetic Story 4
                        </td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="40"
                          align="center"
                          bgcolor="#f5f5f5"
                          class="style63"
                        >
                          90점 이상
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA G1.4
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">
                          <a @click="testgo('1')">
                            <div
                              class="btn btn-success"
                              style="
                                padding: 5% 20%;
                                font-size: 20px;
                                margin: 10px;
                                font-weight: bold;
                              "
                            >
                              START
                            </div>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    <table
                      class="test_table"
                      style="
                        background-color: #fff;
                        font-size: 14px;
                        margin-top: 20px;
                      "
                    >
                      <tr>
                        <td
                          width="135"
                          height="30"
                          rowspan="2"
                          align="center"
                          bgcolor="#9950b0"
                          class="style39"
                          style="line-height: 20px; color: #fff"
                        >
                          Score Range
                        </td>
                        <td height="31" align="center" bgcolor="#eae5ff">
                          <span
                            class="style63"
                            style="color: #333; font-size: 15px"
                            >추천 교재
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="192"
                          height="30"
                          align="center"
                          bgcolor="#eae5ff"
                          class="style39"
                        >
                          <span
                            class="style63"
                            style="color: #333; font-size: 13px"
                            >Main Line</span
                          >
                        </td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="40"
                          align="center"
                          class="style63"
                          bgcolor="#f5f5f5"
                        >
                          0 ~ 60점
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA G2.1
                        </td>
                      </tr>
                      <tr>
                        <td height="40" align="center" class="style63">
                          60 ~ 70점
                        </td>
                        <td align="center" class="style63">LA G2.4</td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="40"
                          align="center"
                          class="style63"
                          bgcolor="#f5f5f5"
                        >
                          70 ~ 80점
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA Nonfiction A1
                        </td>
                      </tr>

                      <tr>
                        <td height="40" align="center" class="style63">
                          80 ~ 90점
                        </td>
                        <td align="center" class="style63">LA Nonfiction B1</td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="40"
                          align="center"
                          bgcolor="#f5f5f5"
                          class="style63"
                        >
                          90점 이상
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA Nonfiction C1
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <a @click="testgo('2')">
                            <div
                              class="btn btn-warning"
                              style="
                                padding: 5% 20%;
                                font-size: 20px;
                                margin: 10px;
                                font-weight: bold;
                              "
                            >
                              START
                            </div>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    <table
                      class="test_table"
                      style="
                        background-color: #fff;
                        font-size: 14px;
                        margin-top: 20px;
                      "
                    >
                      <tr>
                        <td
                          width="135"
                          height="30"
                          rowspan="2"
                          align="center"
                          bgcolor="#dc5968"
                          class="style39"
                          style="line-height: 20px; color: #fff"
                        >
                          Score Range
                        </td>
                        <td height="31" align="center" bgcolor="#ffdadb">
                          <span
                            class="style63"
                            style="color: #333; font-size: 15px"
                            >추천 교재
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="192"
                          height="30"
                          align="center"
                          bgcolor="#ffdadb"
                          class="style39"
                        >
                          <span
                            class="style63"
                            style="color: #333; font-size: 13px"
                            >Main Line</span
                          >
                        </td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="50"
                          align="center"
                          bgcolor="#f5f5f5"
                          class="style63"
                        >
                          0 ~ 70점
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA G3.1
                        </td>
                      </tr>
                      <tr>
                        <td height="50" align="center" class="style63">
                          70 ~ 80점
                        </td>
                        <td align="center" class="style63">LA G3.2</td>
                      </tr>
                      <tr bgcolor="#E8F3F4">
                        <td
                          height="50"
                          align="center"
                          bgcolor="#f5f5f5"
                          class="style63"
                        >
                          80 ~ 90점
                        </td>
                        <td align="center" bgcolor="#f5f5f5" class="style63">
                          LA G3.3
                        </td>
                      </tr>

                      <tr>
                        <td height="50" align="center" class="style63">
                          <span class="style63">90점 이상 </span>
                        </td>
                        <td align="center" class="style63">LA G3.4</td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <a @click="testgo('3')">
                            <div
                              class="btn btn-primary"
                              style="
                                padding: 5% 20%;
                                font-size: 20px;
                                margin: 10px;
                                font-weight: bold;
                              "
                            >
                              START
                            </div>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          class="col-lg-6 offset-lg-3 search_box"
          v-if="this.$root.guiPerm == 'ROOT'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
  },
  mounted() {},
  methods: {
    testgo(level) {
      axios
        .post("/alstest", {
          level: level,
          name: this.name,
          phone: this.phone,
          school_1: this.school_1,
          school_2: this.school_2,
          grade: this.grade,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "생성 실패하였습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "리다이렉트 중입니다...",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            //location.href = response.data.url;
            var openNewWindow = window.open("about:blank");
            openNewWindow.location.href = response.data.url;
          }
        });
    },
  },
  data() {
    return {
      name: "",
      phone: "",
      school_1: "",
      school_2: "",
      grade: "",
    };
  },
};
</script>
